const primaryMain = '#002853';
const primaryMainOpacity = 'rgba(0, 40, 83, 0.9)';
const secondaryMain = '#0085CA';
const secondaryMainOpacity = 'rgba(0, 133, 202, 0.5)';
const secondaryLight = '#116999';
const tertiaryMain = '#000000';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
